var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop)?_c('div',{attrs:{"id":"ExportButton"}},[_c('button',{on:{"click":_vm.exportClick}},[_vm._v("Export")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }